<template>
  <div class="modals">
    <el-dialog
      width="40%"
      :title="socialPostModalTitle"
      :visible.sync="socialPostModal"
      :center="true"
      :close-on-click-modal="false"
      :top="defaultTop"
    >
      <div class="info">
        <el-tooltip class="item" effect="dark" content="Help" placement="bottom">
          <i @click="innerInfoDialogIsVisible = true" type="info" class="el-icon-info"></i>
        </el-tooltip>
      </div>
      <el-dialog
        width="40%"
        :center="true"
        title="How to"
        :visible.sync="innerInfoDialogIsVisible"
        append-to-body
      >
        <el-carousel
          :interval="4000"
          type="card"
          height="200px"
          :initial-index="0"
          :autoplay="false"
          trigger="click"
        >
          <el-carousel-item v-for="(instruction, index) in instructions" :key="index">
            <h2 style="text-align: center;">
              <strong>Step {{ index + 1}}</strong>
            </h2>
            <h2 style="text-align: center;">{{ instruction }}</h2>
          </el-carousel-item>
        </el-carousel>
      </el-dialog>
      <social-posts-container
        v-if="socialPostModal"
        :channels="socialChannels"
        @close="closeSocialPostModal"
      ></social-posts-container>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import SocialPostsContainer from '@/containers/social/SocialPostsContainer';

export default {
  name: 'ModalContainer',

  components: {
    SocialPostsContainer,
  },

  data: () => ({
    defaultTop: '5vh',
    innerInfoDialogIsVisible: false,
    instructions: [
      'Make sure you have a social media channel linked with your company, you can add media channel at the "Channels" dashboard',
      'Select the social platforms you want to post to',
      'You can add media like pictures or video for the post',
      'You can schedule the time and date for the post, if you want to post now you dont have to schedule the post',
      'Now you can click on Send to publish the post',
    ],
  }),

  computed: {
    ...mapGetters('channel', ['socialChannels']),
    ...mapState('social', ['post', 'isEditing']),
    socialPostModal: {
      get() {
        return this.$store.state.modals.socialPostModal;
      },
      set() {
        this.$store.dispatch('modals/hideSocialPostDialog');
      },
    },
    socialPostModalTitle() {
      return this.isEditing ? 'Edit Post' : 'New Post';
    },
  },

  methods: {
    closeSocialPostModal() {
      this.$store.dispatch('modals/hideSocialPostDialog');
    },
  },
};
</script>

<style scoped>
.info {
  margin: auto;
  width: 50%;
  text-align: center;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>



// WEBPACK FOOTER //
// ModalContainer.vue?86c156ac